export default __webpack_public_path__ + "static/media/REPORT_ICONA.3a5d0f20.svg";